<template>
    <b-modal
        id="combined-add-personal-goal-modal"
        v-model="modal"
        modal-class="apprentice-default-modal"
        size="md"
        :title="$t('common.add_learning_goal')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-title="$t('common.save')"
        ok-variant="primary"
        @ok="onOk">
        <div class="add-combined-personal-goal">
            <b-alert
                v-if="hasError"
                show
                variant="danger">
                {{ $t('personal_goals.not_set_bot_goals') }}
            </b-alert>
            <b-alert
                v-if="ungradedCurrentPersonalGoalsIn"
                show
                variant="warning">
                {{ $t('personal_goals.current_goals_not_rated_yet') }}
            </b-alert>

            <b-form-group
                class="first-personal-goal-title-group"
                :label="$t('personal_goals.first_goal')"
                label-for="personal-goal-first-title-input">
                <b-form-input
                    id="personal-goal-second-title-input"
                    v-model="primaryPersonalGoalTitle"
                    :placeholder="$t('personal_goals.first_goal')">
                </b-form-input>
            </b-form-group>

            <b-form-group
                class="second-personal-goal-title-group"
                :label="$t('personal_goals.second_goal')"
                label-for="personal-goal-second-title-input">
                <b-form-input
                    id="personal-goal-first-title-input"
                    v-model="secondaryPersonalGoalTitle"
                    :placeholder="$t('personal_goals.second_goal')">
                </b-form-input>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-combined-add-personal-goal-modal-component',
    props: {
        ungradedCurrentPersonalGoalsIn: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            primaryPersonalGoalTitle: '',
            secondaryPersonalGoalTitle: '',
            hasError: false,
            modal: false,
        };
    },
    methods: {
        onOk(bvModalEvent) {
            this.hasError = false;
            if (this.primaryPersonalGoalTitle === '' || this.secondaryPersonalGoalTitle === '') {
                bvModalEvent.preventDefault();
                this.hasError = true;
                return;
            }
            this.$emit('store-personal-goal', {
                primaryPersonalGoalTitle: this.primaryPersonalGoalTitle,
                secondaryPersonalGoalTitle: this.secondaryPersonalGoalTitle,
            });
        },

        show() {
            this.modal = true;
            this.primaryPersonalGoalTitle = '';
            this.secondaryPersonalGoalTitle = '';
            this.hasError = false;
        },
    },
};
</script>

<style scoped lang="scss">
.first-personal-goal-title-group {
    margin-bottom: $grid-gutter-width;
}
</style>
